module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/04-4b78d676be68a7b8a610e80f3ff077bc.jpg";